import React from 'react';
import _ from 'lodash';

import {
  Box,
  styled,
  ToggleButton as MuiToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup
} from '@mui/material';

import * as dataService from './dataService';



const ToggleButton = styled(MuiToggleButton)({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start'
});

const ToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));

const PlaceholderBox = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(8)
}));



export interface IProps {
  orderId: string;

  selectedRecordId: string;
  onSelectRecord: (id: string) => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);



  React.useEffect(() => {
    if (queryTuple.data.orderNumber) {
      window.document.title = `Interchange: ${queryTuple.data.orderNumber}`;
    }
  }, [queryTuple.data.orderNumber]);



  return (queryTuple.called && !queryTuple.loading) ? (
    <ToggleButtonGroup
      exclusive
      disabled={_.isEmpty(queryTuple.data.records)}
      value={props.selectedRecordId}
      onChange={(event, value) => {
        if (value) {
          props.onSelectRecord(value);
        }
      }}>
      <ToggleButton
        value={props.orderId}
        color="primary">
        {queryTuple.data.orderNumber}
      </ToggleButton>

      {_.map(queryTuple.data.records, record => (
        <ToggleButton
          key={record.id}
          value={record.id}
          color="primary">
          {record.recordNumber}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  ) : <PlaceholderBox />;
};
